var map = {
	"./template.betgalaxy": 2061,
	"./template.betgalaxy.tsx": 2061,
	"./template.betprofessor": 1861,
	"./template.betprofessor.tsx": 1861,
	"./template.betroyale": 1862,
	"./template.betroyale.tsx": 1862,
	"./template.default": 706,
	"./template.default.tsx": 706,
	"./template.fiestabet": 1863,
	"./template.fiestabet.tsx": 1863,
	"./template.puntcity": 1864,
	"./template.puntcity.tsx": 1864,
	"./template.puntgenie": 1865,
	"./template.puntgenie.tsx": 1865,
	"./template.questbet": 1866,
	"./template.questbet.tsx": 1866,
	"./template.ts": 994,
	"./template.volcanobet": 1867,
	"./template.volcanobet.tsx": 1867,
	"./template.wellbet": 1868,
	"./template.wellbet.tsx": 1868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2791;